<ng-container>
    <div mat-dialog-title>
        <h2 *ngIf="!isUpdate">{{"availabilty.Add New Day(s) Off" | translate}}</h2>
        <h2 *ngIf="isUpdate">{{"availabilty.Edit Day(s) Off" | translate}}</h2>

        <button mat-icon-button class="close" (click)="openConfirmDialog()">
            <mat-icon class="pop-close">close</mat-icon>
        </button>
    </div>
    <form [formGroup]="formGroup">
        <mat-dialog-content class="pt-0 pb-0">
            <div class="mat-dialog-body">
                <div *ngIf='dataLoading' class="dataLoading py-5">
                    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
                </div>
                <div class="row" *ngIf="!dataLoading">
                    <div class="col-sm-12">
                        <mat-form-field class="form-group mb-0" hideRequiredMarker>
                            <mat-label>{{"forms.Title in English" | translate}}</mat-label>
                            <input matInput formControlName="title_EN" maxlength="255">
                            <mat-error *ngIf="hasError('title_EN', 'required')">{{ 'forms.Required' | translate }}
                            </mat-error>
                            <!-- <mat-error *ngIf="hasError('title_EN', 'pattern')">
                                {{ 'forms.EntervalidNameinEnglish' | translate }}
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12">
                        <mat-form-field class="form-group mb-0" hideRequiredMarker>
                            <mat-label>{{"forms.Title in Arabic" | translate}}</mat-label>
                            <input matInput formControlName="title_AR" maxlength="255">
                            <mat-error *ngIf="hasError('title_AR', 'required')">{{ 'forms.Required' | translate }}
                            </mat-error>
                            <!-- <mat-error *ngIf="hasError('title_AR', 'pattern')">
                                {{ 'forms.EntervalidNameinArabic' | translate }}
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 mb-2">
                        <div class="grey-list-items">
                            <div class="list-item border border-raduis">
                                <div class=" align-items-center">
                                    <div class="title font-16 fontMedium grey-color">{{'availabilty.Recurring every Year' |
                                        translate}}</div>
                                    <span class="info no-icon font-12">{{"availabilty.Means it is repeating events in the same dates every year; such as holidays or special occasions" | translate}}</span>
                                </div>
                                <div>
                                    <mat-slide-toggle formControlName="recurringYear"></mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 mb-2 mt-3">
                        <div class="grey-list-items">
                            <div class="list-item border border-raduis">
                                <div class=" align-items-center">
                                    <div class="title font-16 fontMedium grey-color">{{'availabilty.Several Days' |
                                        translate}}</div>
                                    <span class="info no-icon font-12">{{"availabilty.Date range and you have to provide a start and end date" | translate}}</span>
                                </div>
                                <div>
                                    <mat-slide-toggle [(ngModel)]="severalDays" [ngModelOptions]="{standalone: true}">
                                    </mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <app-datepicker [label]="'availabilty.Start Date' | translate" [formGroup]="formGroup"
                            [controlName]="'startDate'" [isSubmitted]="isSubmitted"
                            (selectedDateChanged)="changeStartDate()"></app-datepicker>
                    </div>

                    <div class="col-sm-6" [hidden]="!severalDays">
                        <app-datepicker [label]="'availabilty.End Date' | translate" [formGroup]="formGroup"
                            [controlName]="'endDate'" [isSubmitted]="isSubmitted"
                            [min]="endDateMinValue"
                            [showToday]="false"
                            (selectedDateChanged)="formGroup.controls['endDate'].setValue($event)" [required]="severalDays">
                        </app-datepicker>
                    </div>
                    <div class="col-sm-12 mb-2 mt-3">
                        <div class=" d-flex align-items-center">
                            <span class="font-16 fontRegular">{{'restaurant.Branches' | translate}}</span>
                            <a class="font-14 fontRegular grey-color ml-auto preventSelection"
                                [ngClass]="{'disable-link': disableButton}"
                                (click)="selectAllBranches()">
                                <span *ngIf="!isSelected">{{'availabilty.Select All Branches' |
                                translate}}</span>
                                <span *ngIf="isSelected">{{'availabilty.Unselect All Branches' |
                                    translate}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-12 mb-2 mt-3">
                        <mat-selection-list class="circle-selection-list text-left" formControlName="branches">
                            <ng-container *ngFor="let item of allRestaurants; index as index">
                                <div class="d-inline-block mr-2">
                                    <mat-list-option class="mb-2" [value]="item.id" checkboxPosition="before">
                                        {{item.name}}
                                    </mat-list-option>
                                </div>
                            </ng-container>
                        </mat-selection-list>
                        <p class="has-error" *ngIf="isSubmitted && !formGroup.controls['branches'].value?.length">{{'forms.Required' | translate}}</p>

                    </div>
                    <div *ngIf='restaurantloading' class="dataLoading py-5">
                        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
                    </div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>
            <button *ngIf="!isUpdate" (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading"
                [class.loading]="loading">
                {{"availabilty.Add Day(s) Off" | translate}}
            </button>

            <button *ngIf="isUpdate" (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading"
            [class.loading]="loading">
                {{"availabilty.Edit Day(s) Off" | translate}}
            </button>
        </mat-dialog-actions>
    </form>
</ng-container>
